export class TeklifGorsel {
    id: number;
    dosya: string;
  
    constructor(obj?: any) {
      if (obj == null) {
        return;
      }
      Object.assign(this, obj);
    }
  
    getUri(): string {
      if (this.dosya) {
        // return '' + this.dosya;
        return 'assets/img/logo.png';
      }
      return '';
    }
  }
  